<template>
  <nav id="sidebar" class="d-md-none" :class="activeClass">
    <div id="closeHandle" class="float-right" v-on:click="close">X</div>
    <b-navbar toggleable="md" class="align-items-start align-items-md-end">
      <template v-for="group in burgerbar">
        <b-navbar-nav class="align-items-start" :test="$i18n.locale" v-bind:key="group.id">
          <template v-for="item in items(group)">
            <b-nav-item
              :href="'#/'+$i18n.locale+'/'+item.route"
              v-if="item.route !== '' && item.route !== 'sprache'"
              :class="{ coming: item.route.substring(0, 1) === '_' }"
              v-bind:key="item.id"
            >
              <div
                class="badge badge-light badge-nav"
                v-if="(item.route === 'dokumente') && (ungelesen > 0)"
              >{{ ungelesen }}</div>
              <span :class="'glyphicons glyphicons-'+item.icon"></span>
              {{ $t(item.name) }}
            </b-nav-item>
            <language v-if="item.route === 'sprache'" v-bind:key="item.id"></language>
            <b-nav-item-dropdown right v-if="item.route === ''" v-bind:key="item.id" >
              <template slot="button-content">
                <span :class="'glyphicons glyphicons-'+item.icon"></span>
                {{ $t(item.name) }}
              </template>
              <b-dropdown-item
                v-for="child in item.children"
                v-bind:key="child.id"
                :href="'#/'+$i18n.locale+'/'+child.route"
                :class="{ coming: child.route.substring(0, 1) === '_' }"
              >
                <span :class="'glyphicons glyphicons-'+child.icon"></span>
                {{ $t(child.name) }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </template>
        </b-navbar-nav>
      </template>
    </b-navbar>
  </nav>
</template>

<script>
import { bus } from "../main";

export default {
  name: "navigation",
  data() {
    return {
      topbar: ["top", "right"],
      burgerbar: ["left"], // right ist neu in topbar ..
      isVisible: false
    };
  },
  computed: {
    ungelesen() {
      return this.$store.state.dokumenteStore.ungelesen;
    },
    activeClass() {
      return this.isVisible ? "active" : "disabled";
    }
  },
  methods: {
    items: function(group) {
      return this.$store.state.navigationStore.navigation.filter(function(
        item
      ) {
        return item.group === group;
      });
    },
    routes: function(group) {
      return this.$router.options.routes.filter(function(item) {
        return item.group === group;
      });
    },
    toggle() {
      this.isVisible = !this.isVisible;
    },
    open() {
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
    }
  },
  created() {},
  mounted() {
    /* keine Messages gewünscht:  http://redmine.tsmtreuhand.ch:32770/issues/633 */
    bus.$on("SidebarToggle", this.toggle);
    bus.$on("SidebarOpen", this.open);
    bus.$on("SidebarClose", this.close);
  }
};
</script>

<style lang="scss">
@import "../../public/css/tsmVars.scss";

#app {
  #sidebar {
    position: relative;
    .navbar-nav {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-direction: column;
      flex-direction: column;
      padding-left: 0;
      margin-bottom: 0;
      list-style: none;
    }
    div#closeHandle {
      position: absolute;
      right: 0;
      z-index: 10;
      font-weight: bold;
      font-size: 1.5em;
      color: $tsmdunkel;
      padding: 0.5em;
    }
  }
}
</style>